import React, { useState, useMemo, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from '../DebtInformation.module.scss'

const PaymentAmount = ({ t, reduxAppProperty, changeObjectPropertyAction, amount, validate, error, isValid, label, setIsError }) => {
  const [isFocussed, SetIsFocussed] = useState(false)

  const [displayAmount, setDisplayAmount] = useState('')

  useEffect(() => {
    setDisplayAmount(amount ? (parseFloat(amount) / 100).toFixed(2) : '')
  }, [amount])

  const handleChange = (e) => {
    try {
      let amt = e.currentTarget.value.trim()

      setDisplayAmount(amt)
      const amount = parseInt(parseFloat(amt).toFixed(2) * 100)
      // const isNum = !isNaN(amount)
      // changeObjectPropertyAction(isNum ? amount : '')
      // validate(amount)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlur = (e) => {
    try {
      SetIsFocussed(false)
      let amt = e.currentTarget.value.trim()
      const amount = parseInt(parseFloat(amt).toFixed(2) * 100)
      const isNum = !isNaN(amount)

      setDisplayAmount(isNum ? parseFloat(amt).toFixed(2) : amt)
      changeObjectPropertyAction(isNum ? amount : '')
      // validate(amount)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const statusClasses = useMemo(() => {
    if (isValid === '') {
      return 'ns-form-group'
    } else if (isValid === true) {
      return 'ns-form-group'
    } else {
      return 'ns-form-group has-error ns-form-group-message-error'
    }
  }, [isValid])

  return (
    <div className={[statusClasses, styles['fields_margin']].join(' ')}>
      <div className="ns-label-wrapper">
        <label className="ns-label" htmlFor="PaymentAmount">
          {label}
        </label>
      </div>
      {isValid === true || isValid === '' ? null : (
        <span id="payment-amount-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
          <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
          <span className="ns-visually-hidden">{t('shared.error')}</span> {t(error)}
        </span>
      )}
      <div className={styles['input_box_div']}>
        <div className={styles['dollor_icon']}>
          <span style={{ fontSize: '18px', fontWeight: 'bolder' }}>$</span>
        </div>
        <input
          className={['fw-10', isValid !== true && isValid !== '' ? 'ns-input--error' : ''].join(' ')}
          id="PaymentAmount"
          name="PaymentAmount"
          type="number"
          aria-describedby="payment-amount"
          onChange={handleChange}
          onBlur={onBlur}
          onFocus={() => SetIsFocussed(true)}
          value={displayAmount}
          autoComplete="off"
          maxLength="12"
        />
        {/* {isValid === true && (
            <div style={{ display: 'inline-flex', marginLeft: '1rem', alignItems: 'center' }}>
              <i className="fa fa-check-circle fa-lg" aria-hidden="true"></i>
            </div>
          )} */}
      </div>
    </div>
  )
}

export default withTranslation('common')(PaymentAmount)
